import { calendarExt } from "../modules/calendar";
import { slidersExt } from "../modules/sliders";
import { subscribeExt } from "../modules/subscribe";

export function homePage() {

    function playInstaVideo() {
        $(".insta-item").on('mouseenter', function() {
            var $video = $(this).find('video');
            if($video.length > 0){
                $video.get(0).play();
            }
        });
        $(".insta-item").on('mouseleave', function() {
            var $video = $(this).find('video');
            if($video.length > 0){
                $video.get(0).pause();
            }
        });
    }

    function fix_size($img_container) {
        var img_cl = $img_container+' img';
        var images = $(img_cl);

        images.each(setsize);

        function setsize() {
            var img = $(this),
                img_dom = img.get(0),
                container = img.parents($img_container);
            if (img_dom.complete) {
                resize();
            } else{
                img.one('load', resize);
            }

            function resize() {
                if ((container.width() / container.height()) < (img_dom.width / img_dom.height)) {
                    img.width('110%');
                    img.height('auto');
                    img.addClass('img-w');
                } else {
                    img.height('110%');
                    img.width('auto');
                    img.addClass('img-h');
                }
            }
        }
    }


    function actions() {
        var bLazy = new Blazy();

        fix_size('.grid-item');
        fix_size('.slic-img');
        fix_size('.side-item');
        fix_size('.item-article a');

        calendarExt();
        slidersExt();
        playInstaVideo();

        if($('body').hasClass('home')) {
            subscribeExt(100);
        }
    }

    actions();

}


// WEBPACK FOOTER //
// ./assets/js/pages/homepage.js